<template>
  <vue-dialog :dialog-data="dialogData">
    <el-form label-width="auto" size="small">
      <el-form-item label="当前权限" class="routes-tree-item">
        <el-scrollbar :view-style="{maxHeight: '450px'}">
          <el-tree ref="tree" :data="routes" :props="defaultProps" default-expand-all node-key="permissionId">
            <div :data-level="node.level" :class="{'last-menu': data.children && !data.children[0].children}" slot-scope="{ node, data }">
              <span :class="data.icon">{{data.label}}</span>
            </div>
          </el-tree>
        </el-scrollbar>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
import {getRoutesTree} from '@router/permission'
export default {
  name: "RolePermission",
  props: {dialogData:Object},
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      routes: []
    }
  },
  async created() {
    await this.init();
    this.initTree();
  },
  methods: {
    initTree() {
      this.$nextTick(() => {
        const domList = document.querySelectorAll(".last-menu");
        [...domList].forEach(dom => {
          const boxDom = dom.parentNode.nextSibling;
          boxDom.classList.add('interface-box');
          boxDom.style.paddingLeft = `${dom.dataset.level * 18}px`;
        })
      })
    },
    async init() {
      let row = this.dialogData.row;
      let nv = {role_id: row.id};
      let res = await this.$Http.getRolePermission(nv);
      if (res?.data) {
        let list = res.data || [];
        this.routes = getRoutesTree(list);
      }
    }
  }
}
</script>

<style scoped>

</style>
